import { useCallback } from 'react'
import { Login as RALogin } from 'react-admin'
import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3'
import Storage from '../../../lib/Storage'
import Logo from '@/icons/logo.svg?react'
import CONSTANTS from '@/constants'

const Login = () => {
  const { setRecaptchaToken } = Storage()

  const onVerify = useCallback(
    (token: string) => {
      setRecaptchaToken(token)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <GoogleReCaptchaProvider reCaptchaKey={CONSTANTS.RECAPTCHA_V3_SITE_KEY}>
      <GoogleReCaptcha onVerify={onVerify} refreshReCaptcha />
      <RALogin
        avatarIcon={<Logo />}
        sx={{
          backgroundImage: 'none',
          '& .MuiAvatar-root': {
            borderRadius: 0,
            width: '200px',
            backgroundColor: 'inherit',
            color: 'primary.main'
          }
        }}
      />
    </GoogleReCaptchaProvider>
  )
}

export default Login
